(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/*import ScrollReveal from 'scrollreveal'
import Headroom from 'headroom.js';
import SmoothScroll from 'smooth-scroll'
import 'flickity-imagesloaded'
import Flickity from 'flickity'
import * as basicLightbox from 'basiclightbox'*/

/**
 * Hamburger
 */
document.querySelector('.hamburger').addEventListener('click', function (e) {
  this.classList.toggle('is-active');
  document.querySelector('.nav__container').classList.toggle('nav--open');
});
/**
 * Move content to correct position
 */

if (document.querySelector('.home') === null) {
  document.querySelector('.main-content-repeat').style.paddingTop = document.querySelector('.main-content--header').clientHeight + 'px';
} else {
  document.querySelector('.push-down').style.paddingTop = document.querySelector('.hero__front--content').clientHeight / 2 + 100 + 'px';
}
/**
 * Filter menu
 */


var filter = document.querySelectorAll('[data-filter]');
var food_containers = document.querySelectorAll('.js-food-container');

if (filter.length > 0) {
  for (var i = 0; i < filter.length; i++) {
    // Click event
    filter[i].addEventListener('click', function (event) {
      // Remove underline
      for (var j = 0; j < filter.length; j++) {
        filter[j].classList.remove('underline');
        filter[j].classList.add('no-underline');
      } // Add underline


      event.target.classList.add('underline');
      event.target.classList.remove('no-underline');

      for (var k = 0; k < food_containers.length; k++) {
        food_containers[k].classList.add('hidden');
      }

      document.querySelector('#' + event.target.dataset.filter).classList.remove('hidden');
    });
  }
}
/**
 * basicLightbox for video modals
 */

/*if (document.querySelector('.js-open-lightbox') !== null) {
  const instance = basicLightbox.create(
    document.querySelector('template')
  )
  document.querySelector('.js-open-lightbox').addEventListener('click', function() {
    instance.show()
  })
}*/

/**
 * Flickity
 */

/*if (document.querySelector('.carousel') !== null) {
  var flkty = new Flickity('.carousel', {
    imagesLoaded: true,
    wrapAround: true,
    pageDots: false
  });
}*/

/**
 * Headroom
 */

/*const header = document.querySelector('header.main')
const headroom = new Headroom(header, {
  tolerance: {
    up : 5,
    down : 5
  },
  onNotTop: function(){
    document.querySelector('header.main').classList.remove('nav--open')
    document.querySelector('.hamburger').classList.remove('is-active')
  }
})

headroom.init()*/

/**
 * ScrollReveal
 */
// ScrollReveal().reveal('.reveal', {
//   distance: '20px'
// })

/**
 * SmootScroll
 */

/*var scroll_buttons = document.querySelectorAll('.js-smoothscroll')
var scroll = new SmoothScroll()
var anchor = document.querySelector('main')
var options = { speed: 700, easing: 'easeOutCubic', updateURL: false }

if (scroll_buttons !== null) {
  for (var i = scroll_buttons.length - 1; i >= 0; i--) {
    scroll_buttons[i].addEventListener('click', function() {
      scroll.animateScroll(anchor, null, options)
    })
  }
}*/

},{}]},{},[1]);
